// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media only screen {
  .dealership-select a {
    cursor: pointer;
    display: inline-block;
    margin-right: 0.5rem;
    border-bottom: 2px solid var(--dms-color);
  }
  .dealership-select a.active {
    border-bottom: 2px solid #fff;
    cursor: default;
  }
  .results-total {
    line-height: 30px;
    color: var(--mc-color-mid-grey);
    font-size: xrem(14px);
    text-align: center;
    padding-top: 10px;
  }
  .result-metadata {
    text-align: left;
  }
  .sort-order-wrapper {
    font-size: 12px;
    float: right;
    font-weight: 500;
  }
  .search-term {
    padding: xrem(12px) 0;
  }
  .dealership-select-container {
    line-height: xrem(33px);
  }
  .dealership-select-container a {
    color: var(--ion-color-primary-contrast);
    text-transform: uppercase;
    font-size: xrem(14px);
    font-weight: 500;
    margin-right: 1rem;
    padding: 0 1rem;
  }
  .scroll-top {
    position: fixed;
    bottom: 15px;
    right: 15px;
    text-align: center;
    opacity: 0;
    background: rgba(0, 0, 0, 0.4);
    cursor: pointer;
    width: xrem(50px);
    height: xrem(50px);
    line-height: xrem(50px);
  }
  .scroll-top a {
    width: xrem(50px);
    height: xrem(50px);
    display: block;
    position: absolute;
    top: 0;
  }
  .scroll-top:before {
    content: "\\e905";
    font-family: "icomoon";
    color: rgba(255, 255, 255, 0.7);
  }
  .scroll-top:hover {
    background: rgba(0, 0, 0, 0.6);
  }
  .scroll-top:hover:before {
    color: rgba(255, 255, 255, 0.9);
  }
  .scroll-top.visible {
    opacity: 1;
  }
  .sort-order-wrapper {
    display: inline-flex;
  }
  .sort-order-wrapper app-select-list label {
    color: var(--mc-text-969696);
  }
  .sort-order-wrapper app-select-list {
    font-weight: 400;
  }
  .sort-order-wrapper app-select-list .dropdown-arrow {
    font-weight: 400;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/shared/contact-list/contact-list.component.scss"],"names":[],"mappings":"AAIA;EAEI;IACI,eAAA;IACA,qBAAA;IACA,oBAAA;IACA,yCAAA;EAJN;EAMM;IACI,6BAAA;IACA,eAAA;EAJV;EAQE;IAII,iBAAA;IACA,+BAAA;IACA,qBAAA;IACA,kBAAA;IACA,iBAAA;EATN;EAYE;IACI,gBAAA;EAVN;EAYE;IACF,eAAA;IACM,YAAA;IACN,gBAAA;EAVA;EAYE;IACG,qBAAA;EAVL;EAaE;IACI,uBAAA;EAXN;EAcO;IACG,wCAAA;IACA,yBAAA;IACA,qBAAA;IACA,gBAAA;IACA,kBAAA;IACA,eAAA;EAZV;EAgBE;IACI,eAAA;IACA,YAAA;IACA,WAAA;IACA,kBAAA;IACA,UAAA;IAGA,8BAAA;IAEA,eAAA;IACA,iBAAA;IACA,kBAAA;IACA,uBAAA;EAjBN;EAmBM;IACI,iBAAA;IACA,kBAAA;IACA,cAAA;IACA,kBAAA;IACA,MAAA;EAjBV;EAqBM;IACI,gBAAA;IACA,sBAAA;IACA,+BAAA;EAnBV;EAsBM;IACI,8BAAA;EApBV;EAsBU;IACI,+BAAA;EApBd;EAwBM;IACI,UAAA;EAtBV;EAyBE;IACI,oBAAA;EAvBN;EAyBU;IACI,4BAAA;EAvBd;EAqBM;IAII,gBAAA;EAtBV;EAuBU;IACI,gBAAA;EArBd;AACF","sourcesContent":["\r\n\r\n\r\n\r\n@media only screen {\r\n\r\n    .dealership-select a {\r\n        cursor: pointer;\r\n        display: inline-block;\r\n        margin-right: 0.5rem;\r\n        border-bottom: 2px solid var(--dms-color);\r\n\r\n        &.active {\r\n            border-bottom: 2px solid #fff;\r\n            cursor: default;\r\n        }\r\n    }\r\n\r\n    .results-total {\r\n        //  $bgcolor1;\r\n        // border-top: xrem(1px) solid $border-medium;\r\n        // border-bottom: xrem(1px) solid $border-medium;\r\n        line-height: 30px;\r\n        color: var(--mc-color-mid-grey);\r\n        font-size: xrem(14px);\r\n        text-align: center;\r\n        padding-top: 10px;\r\n    }\r\n\r\n    .result-metadata {\r\n        text-align:left;\r\n    }\r\n    .sort-order-wrapper {\r\n\t\tfont-size: 12px;\r\n        float:right;\r\n\t\tfont-weight: 500;\r\n    }\r\n    .search-term{\r\n       padding: xrem(12px) 0;\r\n    }\r\n\r\n    .dealership-select-container {\r\n        line-height: xrem(33px);\r\n        // @include box-shadow(0 4px 4px 0 rgba(0,0,0,0.1));\r\n\r\n         a {\r\n            color: var(--ion-color-primary-contrast);;\r\n            text-transform: uppercase;\r\n            font-size: xrem(14px);\r\n            font-weight: 500;\r\n            margin-right: 1rem;\r\n            padding: 0 1rem;\r\n        }\r\n    }\r\n\r\n    .scroll-top {\r\n        position: fixed;\r\n        bottom: 15px;\r\n        right: 15px;\r\n        text-align: center;\r\n        opacity: 0;\r\n        // transition: all .2s ease-in-out;\r\n\r\n        background: rgba(0,0,0,0.4);\r\n\r\n        cursor: pointer;\r\n        width: xrem(50px);\r\n        height: xrem(50px);\r\n        line-height: xrem(50px);\r\n\r\n        a {\r\n            width: xrem(50px);\r\n            height: xrem(50px);\r\n            display: block;\r\n            position: absolute;\r\n            top: 0;\r\n        }\r\n\r\n\r\n        &:before {\r\n            content: \"\\e905\";\r\n            font-family: \"icomoon\";\r\n            color: rgba(255,255,255,0.7);\r\n        }\r\n\r\n        &:hover {\r\n            background: rgba(0,0,0,0.6);\r\n\r\n            &:before {\r\n                color: rgba(255,255,255,0.9);\r\n            }\r\n        }\r\n\r\n        &.visible {\r\n            opacity: 1;\r\n        }\r\n    }\r\n    .sort-order-wrapper {\r\n        display:inline-flex;\r\n        app-select-list {\r\n            label {\r\n                color: var(--mc-text-969696);\r\n            }\r\n            font-weight: 400;\r\n            .dropdown-arrow {\r\n                font-weight: 400;\r\n            }\r\n        }\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
